import React, { useState, useCallback } from "react";
import { Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../API/apiService";
import { API_ENDPOINTS } from "../../../API/endpoints";
import { socketEvents } from "../../../settings/socketEventName";
import { useUserSelfStore } from "../../../store/apis/useUserStore";
import { useSocketEvents } from "../../../socket/hooks/useSocketEvents";
import { localStorageUtil } from "../../../utils/CommonFunctions";
import { useBridgeStore } from "../../../store/apis/useBridgeStore";

const ConfirmationModal = ({ isOpen, onClose, channelId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const { emit } = useSocketEvents();

  const userSelfData = useUserSelfStore((state) => state.userSelfData);
  const triggerDraftRefresh =  useBridgeStore(store => store.triggerDraftRefresh)
  const navigate = useNavigate();

  const updateUserDataAndNavigate = useCallback(
    (defaultChannelId) => {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      userData.lastActiveChat = {
        id: defaultChannelId,
        type: "channel",
      };

      localStorage.setItem("userData", JSON.stringify(userData));
      localStorage.setItem("current_id", defaultChannelId);
      navigate(`/elsnertech/channels/${defaultChannelId}`);
    },
    [navigate]
  );

  const leaveChannelApi = useCallback(async () => {
    if (!channelId) {
      console.error("Channel ID is required");
      return;
    }

    setLoading(true);
    try {
      const response = await ApiService.put(
        `${API_ENDPOINTS.leaveChannelApi}/${channelId}`
      );

      if (response?.status === 1) {
        localStorageUtil.removeItem(`draft-${channelId}`);
        triggerDraftRefresh(Date.now());
        const defaultChannelId = localStorage.getItem("defaultChannelId");

        if (defaultChannelId) {
          updateUserDataAndNavigate(defaultChannelId);
        }

        let members = response?.data?.members.map((item) => item?.id);
        emit(socketEvents.LEAVE_CHANNEL, {
          data: {
            senderId: userSelfData?._id,
            receiverId: members,
            channelId: channelId,
          },
        });
        localStorageUtil.removeItem(`draft-${channelId}`);
        onSuccess?.();
        onClose();
      }
    } catch (error) {
      console.error("Error leaving channel:", error);
    } finally {
      setLoading(false);
    }
  }, [channelId, updateUserDataAndNavigate, onSuccess, onClose]);

  const handleCancel = useCallback(() => {
    if (!loading) {
      onClose();
    }
  }, [loading, onClose]);

  const modalFooter = [
    <Button
      key="cancel"
      onClick={handleCancel}
      className="text-btn"
      disabled={loading}
    >
      Cancel
    </Button>,
    <Button
      key="leave"
      type="primary"
      onClick={leaveChannelApi}
      loading={loading}
      className="danger-btn ant-btn"
    >
      Leave
    </Button>,
  ];

  return (
    <Modal
      title="Confirm Leave Channel"
      open={isOpen}
      onCancel={handleCancel}
      footer={modalFooter}
      className="ec-modal rename-channel-modal"
      width={600}
      style={{ top: 20 }}
      closable={!loading}
      maskClosable={!loading}
    >
      <div className="delete-msg-confirmation">
        <span>Are you sure you want to Leave this Channel?</span>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
